// Sample card from Airbnb
import React from "react";
import { Link } from "react-router-dom"
import classes from "./styles.module.css"; 
import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import APIConfig from "../../../../api/APIConfig";
import ReactLoading from "react-loading";

import {
    Box,
    Center,
    Heading,
    Text,
    Button,
    VStack,
    StackDivider,
    HStack,
} from '@chakra-ui/react';

    function formatDate(string){
        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(string).toLocaleDateString([],options);
    }


function DataPribadiPeserta() {
    const [namaPeserta, setNamaPeserta] = useState('');
    const [jenisKelaminPeserta, setJenisKelaminPeserta] = useState('');
    const [tempatKelahiranPeserta, setTempatKelahiranPeserta] = useState('');
    const [tanggalKelahiranPeserta, setTanggalKelahiranPeserta] = useState('');
    const [spinner, setSpinner] = useState(false); 

    const getPesertaById = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/peserta/${id}`);
        const data = await response.data
        setNamaPeserta(data.namaPeserta);
        setJenisKelaminPeserta(data.jenisKelaminPeserta);
        setTempatKelahiranPeserta(data.tempatKelahiranPeserta);
        setTanggalKelahiranPeserta(new Date(data.tanggalKelahiranPeserta));
        console.log("ada")
        setSpinner(false);
    };

    const { id } = useParams();

    useEffect(() => {
        getPesertaById();
        
    }, []);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <div className="container">
        <div>
        <Center py={6} paddingBottom={20}>
        <VStack align='stretch' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'3xl'}>
                Profil
            </Text>
            <HStack color={'gray.500'} pb={3}>
                <Link to="/peserta/profile"> Profil </Link>
                <p> / </p>
                <Link to={`/peserta/profile/isi-datapribadi/${id}`}> Data Diri </Link>
            </HStack>

            <Box
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>
                <VStack 
                divider={<StackDivider borderColor='gray.200' />}
                spacing={4}
                align='stretch'
                >
                    <Heading
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Data Diri
                    </Heading>
                    <div>
                        <h3 className={classes.h} >Nama Lengkap</h3>
                        <p className={classes.p}>{namaPeserta}</p>
                    </div>

                    <div>
                        <h3 className={classes.h}>Jenis Kelamin</h3>
                        {jenisKelaminPeserta === 0 ? (
                            <p className={classes.p}>Perempuan</p> 
                        ) : (
                            <p className={classes.p}>Laki-laki</p> 
                        )}
                    </div>

                    <div>
                        <h3 className={classes.h}>Tempat Lahir</h3>
                        <p className={classes.p}>{tempatKelahiranPeserta}</p>
                    </div>

                    <div>
                        <h3 className={classes.h}>Tanggal Lahir</h3>
                        <p className={classes.p}>{formatDate(tanggalKelahiranPeserta)}</p>
                    </div>

                </VStack>
                <Center pt={6}>
                    <Link to={`/peserta/profile/isi-datapribadi/${id}`}>
                        <Button p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                            <h3 className={classes.h}>Edit profil</h3>
                        </Button>
                    </Link>
                    
                </Center>
            </Box>)
        </VStack>
        </Center>
      </div>
      </div>
    );
    }
export default DataPribadiPeserta;